import {Component, inject} from '@angular/core'
import {LoanService} from '../../../services/loan.service'
import {KalpItemComponent} from '../kalp-item/kalp-item.component'

@Component({
  selector: 'spb-kalp-tax-reduction',
  templateUrl: './tax-reduction.component.html',
  styleUrls: ['../kalp.component.scss'],
  imports: [KalpItemComponent]
})
export class TaxReductionComponent {
  public readonly loanService = inject(LoanService)
}
